<template>
  <div class="page-summary course-summary plan-summary">
    <div class="page-summary__section course-title">
      <div class="page-summary__label">{{ course.code }}</div>
      <div class="page-summary__course-title">{{ course.name }}</div>
    </div>
    <div class="page-summary__section course-details">
      <dl v-if="courseMajors" class="page-summary__value-pair">
        <div v-for="major in courseMajors" :key="major.relationship.code">
          <dt class="page-summary__label">{{ major.relationship.code }}</dt>
          <dd class="page-summary__title">{{ major.relationship.name }}</dd>
        </div>
      </dl>
      <dl v-if="courseMinors" class="page-summary__value-pair">
        <div v-for="minor in courseMinors" :key="minor.relationship.code">
          <dt class="page-summary__label">{{ minor.relationship.code }}</dt>
          <dd class="page-summary__title">{{ minor.relationship.name }}</dd>
        </div>
      </dl>
    </div>
    <div v-show="studentType" class="page-summary__section student-pref">
      <dl class="page-summary__value-pair">
        <dt>Student type</dt>
        <dd>{{studentType}}</dd>
      </dl>
      <dl v-show="studyOption" class="page-summary__value-pair">
        <dt>Enrolment pattern</dt>
        <dd>{{studyOption}}</dd>
      </dl>
      <dl class="page-summary__value-pair">
        <dt class="page-summary__label" v-show="startPeriod && startYear">Start date</dt>
        <dd>{{startPeriod && startYear ? `${startPeriod}, ${startYear}` : ''}}</dd>
      </dl>
    </div>
    <div v-if="selectedCredits > 0" class="page-summary__section credits">
      <div class="page-summary__credits">{{ selectedCredits }} / {{course.requiredCredits}}</div>
      <div class="page-summary__label">points selected</div>
    </div>
    <div v-else class="page-summary__section credits">
      <div class="page-summary__credits">{{ course.requiredCredits }}</div>
      <div class="page-summary__label">Total credit points</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import StudentPreferences from 'common/models/student-preferences.js'
export default {
  props: {
    courseCode: {
      type: String
    },
    courseTitle: {
      type: String
    },
    requiredCredits: {
      type: Number
    },
    studentType: {
      type: String
    },
    studyOption: {
      type: String
    },
    startYear: {
      type: String
    },
    teachingPeriod: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      studyPreference: 'preferences/getSelectedStudyPreferences',
      course: 'courses/getSelectedCourse',
      totalCredits: 'units/getTotalCredits',
      selectedItems: 'units/getSelectedCurriculumItems'
    }),
    startPeriod() {
      if (this.teachingPeriod) return StudentPreferences.courseloopOptionToTeachingPeriod(this.teachingPeriod).shortLabel
    },
    selectedCredits() {
      return this.totalCredits('root', false) || 0
    },
    courseMajors() {
      return this.selectedItems.filter((item) => item.relationship.type === 'Major')
    },
    courseMinors() {
      return this.selectedItems.filter((item) => item.relationship.type === 'Minor')
    }
  }
}
</script>
